import React from 'react';
import '../../utils/assertions.es.js';
import { runIfFn } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Flex } from '../Flex/Flex.es.js';
import { useNavBarContext } from './NavBarContext.es.js';

const NavBarSubMenu = ({ children }) => {
  const { isMobile } = useNavBarContext();
  return /* @__PURE__ */ React.createElement(Flex, {
    alignItems: "center",
    height: "100%"
  }, runIfFn(children, { isMobile }));
};
NavBarSubMenu.displayName = "NavBar.SubMenu";

export { NavBarSubMenu };
//# sourceMappingURL=NavBarSubMenu.es.js.map
